import script from "./DeleteEntitlementOwnerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteEntitlementOwnerModal.vue?vue&type=script&setup=true&lang=js"

export default script